import useTradeStreamer from 'hooks/useTradeStreamer'
import useExchangeInfoDataProvider from 'hooks/useExchangeInfoDataProvider'
import useSymbolInfoDataProvider from 'hooks/useSymbolInfoDataProvider'
import useRouter from 'hooks/useRouter'
import useAuth from 'hooks/useAuth'
import useDialogStatus from 'hooks/useDialogStatus'
import useOpenAccountDataProvider from 'hooks/useOpenAccountDataProvider'
import useFeeDataProvider from 'hooks/useFeeDataProvider'
import useLeverageDataProvider from 'hooks/useLeverageDataProvider'
import {DIALOGS} from 'constants'
import GraphView from './Graph'
import GraphViewMobile from './GraphMobile'
import OrderBookView from './OrderBook'
import TradeListView from './TradeList'
import HistoryView from './TradeHistory'
import Grid from './Grid'
import Header from '../Header/index'
import HeaderMobile from '../HeaderMobile/index'
import TransferDialog from './Dialogs/TransferDialog'
import LeverageDialog from './Dialogs/LeverageDialog'
import RenderOrderForm from './RenderOrderForm'
import DepthChartView from './DepthChartView'

function TradeView ({i18n}) {
  const router = useRouter()
  const {symbol} = router.query

  useAuth()
  useOpenAccountDataProvider()
  useTradeStreamer(symbol)
  useExchangeInfoDataProvider()
  useSymbolInfoDataProvider(symbol)
  useFeeDataProvider(symbol)
  useLeverageDataProvider(symbol)

  const {dialogStatus, switchDialog} = useDialogStatus(DIALOGS.TRANSFER_DIALOG)
  const {dialogStatus: leverageDialogStatus} = useDialogStatus(DIALOGS.LEVERAGE_DIALOG)
  return (
    <Grid>
      <Header i18n={i18n} />
      <HeaderMobile i18n={i18n} />
      <GraphView i18n={i18n} />
      <GraphViewMobile i18n={i18n} />
      <OrderBookView i18n={i18n} />
      <DepthChartView i18n={i18n} />
      <TradeListView i18n={i18n} />
      <HistoryView i18n={i18n} />
      <RenderOrderForm i18n={i18n} />
      {dialogStatus && (
        <TransferDialog i18n={i18n} onClose={() => switchDialog(DIALOGS.TRANSFER_DIALOG)} />
      )}
      {leverageDialogStatus && (
        <LeverageDialog i18n={i18n} onClose={() => switchDialog(DIALOGS.LEVERAGE_DIALOG)} />
      )}
    </Grid>
  )
}

export default TradeView
